export default __webpack_public_path__ + "static/media/dog-green.1169370e.svg";